import { gql } from "@apollo/client";

const requestFileUploadAllocationMutation = gql`
  mutation {
    requestFileUploadAllocation {
      fileIdentifier
      url {
        formatted
      }
    }
  }
`;

export default requestFileUploadAllocationMutation;
